import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { DesignationDto } from 'src/app/models/DesignationDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { userVM } from 'src/app/models/requests/userVm';
import { RoleDto } from 'src/app/models/RoleDto';
import { DepartmentsService } from 'src/app/services/departments.service';
import { DesignationService } from 'src/app/services/designation.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RolesService } from 'src/app/services/roles.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-newuser',
  templateUrl: './newuser.component.html',
  styleUrls: ['./newuser.component.css']
})
export class NewuserComponent implements OnInit {

  Roles: RoleDto[] = [];
  Designations: DesignationDto[] = [];
  Departments: DepartmentDto[] = [];
  Locations: LocationDto[] = [];
  Functions:FunctionDto[]=[];

  firstname: string = '';
  lastname: string = '';
  email: string = '';
  phoneNumber: string = '';
  sapId: string = '';
  selectedDepartmentId: number = 0;
  selectedDesignationId: number = 0;
  selectedRoleId: number = 0;
  selectedLocationId:number=0;
  selectedFunctionId:number=0;
  isManager:boolean=false;
  selectedManagerId:string="";
  Managers:Profile[]=[];
  isManagerVisible:boolean=false;
  allowedRoles:RoleDto[]=[];
  listOfSelectedValues :any[]=[];
  selectedRoleIds:number[]=[];
  selectedItem: any[] = [];
  selectedRoles:any;
  
  groupForm: FormGroup ;
  constructor(private fb: FormBuilder, private functionService:FunctionsService,   private notification: NotificationService, private userService: UserService, private locationService:LocationsService,
    private designation: DesignationService, private department: DepartmentsService, private roleService:RolesService) {
      this.groupForm = this.fb.group({
        selectedRoles: ["", Validators.nullValidator],
      });
  }

  ngOnInit(): void {
    this.loadRecoords();
  }
  async loadRecoords() {

    let resDesigna = await this.designation.getDesignations().toPromise();
    this.Designations = <DesignationDto[]>resDesigna.responseData;

    let resDeparts = await this.department.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;
    let resRoles = await this.roleService.getRoles().toPromise();
    this.Roles = <RoleDto[]>resRoles.responseData;

    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;
  
  
    let functions = await this.functionService.getAllFunctions().toPromise();
    this.Functions = <FunctionDto[]>functions.responseData;
    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;


        
   let  resultRoles = await this.roleService.getRoles().toPromise(); 
   this.allowedRoles = <RoleDto[]> resultRoles.responseData;


  }

  
  async onChangeDepartment(event:string)
  {
 /*;
 const dptId:number=parseInt(event);
 
 let functions = await this.functionService.getByDepartmentId(dptId).toPromise();
 this.Functions = <FunctionDto[]>functions.responseData;
 ;
 */
   }

   onChangeDesignation(event:string)
   {
    ;
    const dptId:number=parseInt(event);
    let item = this.Designations.find(i => i.id === dptId);

if(item?.name=== "Requester")
{
  this.isManagerVisible=true;

}
else
{
  this.isManagerVisible=false;
}

if(item?.name=== "Head of Dept")
{
this.isManager = true;

}
 }

  onSubmit(): void {
;
var rp:[]=this.groupForm?.get("selectedRoles")?.value;

const selectedIds =rp.map(({ id }) => id);

if(this.isManagerVisible && this.selectedManagerId.length==0)
{

  this.notification.sendMessage({
    message: 'Manager (N+1) not selected',
    type: NotificationType.error
  });

  return;

}
if(this.firstname.length==0 ||this.lastname.length==0||this.phoneNumber.length==0 ||this.email.length==0)
{

  this.notification.sendMessage({
    message: 'Required information not entered',
    type: NotificationType.error
  });

  return;

}
if(this.selectedLocationId==0 ||this.selectedDesignationId==0||this.selectedFunctionId==0 ||this.selectedDepartmentId==0)
{

  this.notification.sendMessage({
    message: 'Required information not entered',
    type: NotificationType.error
  });

  return;

}

;
    let userVm: userVM = {
      firstName: this.firstname,
      lastName: this.lastname,
      email: this.email,
      departmentId: this.selectedDepartmentId,
      roleIds:   selectedIds, //this.selectedRoleId,
      designationId: this.selectedDesignationId,
      phoneNumber: this.phoneNumber,
      locationId:this.selectedLocationId,
      functionId:this.selectedFunctionId,
      sapId:this.sapId,
      isManager:this.isManager,
      managerId:this.selectedManagerId
    };

    let item = this.Designations.find(i => i.id === userVm.designationId);
    if(item?.name==="Functional Head")
    {
      userVm.isManager = true;

    }

    this.userService.createUser(userVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // console.debug(`User Created successfully ${data}`);
          this.firstname = '';
          this.lastname = '';
          this.email== '';
          this.phoneNumber= '';

          location.reload();
          

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
